// extracted by mini-css-extract-plugin
export default {"table":"BuildingTemplates_table__tJN+d","search":"BuildingTemplates_search__2Q1mw"};